import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_INCOME_VERIFICATION_GET_SCREENING_URL,
} from 'api/actionTypes';

export default async function getScreeningUrl(
  { state, apiClient },
  { incomeVerificationId },
) {
  typeCheck('incomeVerificationId::PositiveNumber', incomeVerificationId);

  const incomeVerificationScreeningUrl = await apiClient.postWithState({
    action: SR_API_ACTION_INCOME_VERIFICATION_GET_SCREENING_URL,
    state: state,
    payload: {
      incomeVerificationId,
    },
  });

  return incomeVerificationScreeningUrl;
}
